import { auth } from "./firebase"

import { getUrl } from "../../../../state/async-actions/mangrove"

import * as actions from "../../../../state/actions"

// Versturen van registratie verzoek
export function sendRegisterEmail(server, appid, firebaseUser, callback) {
  const parameters = {
    appid: appid,
    name: firebaseUser.user.displayName,
    email: firebaseUser.user.email,
    uid: firebaseUser.user.uid
  }

  const functionName = "mangrove.appfunctions.SendRegisterEmail"
  const url = getUrl(server, functionName, parameters)

  return async function (dispatch) {
    return await fetch(url)
      .then(response => {
        if (callback) {
          callback(firebaseUser)
        }
        return null
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function sendRegisterEmail`, type: "error" } })
      })
  }
}

// Account aanmaken met email en wachtwoord
export const doCreateUserWithEmailAndPassword = (email, name, password, dispatch, callback) => {
  auth.createUserWithEmailAndPassword(email, password)
    .then(function (firebaseUser) {
      if (firebaseUser) {
        if (!firebaseUser.user.emailVerified) {
          alert("gebruiker is niet verified")
          // Als email niet verified is moet er een email worden verzonden...
          // sendRegisterEmail("tsws", 999, firebaseUser)
        }

        firebaseUser.user.updateProfile({
          displayName: name
        })
          .then(function () {
            const userinfo = {
              uid: firebaseUser.user.uid,
              token: firebaseUser.user.xa,
              name: name,
              email: firebaseUser.user.email,
              verified: firebaseUser.user.emailVerified
            }

            if (callback) {
              callback(firebaseUser)
            }

            dispatch({ type: actions.SET_ERROR, error: { message: "Er is een account verzoek verstuurd.", type: "info", duration: 6000 } })
            dispatch({ type: actions.SET_AUTH_USER, userinfo: userinfo })
          })
      }
    })
    .catch(function (error) {
      dispatch({ type: actions.SET_ERROR, error: { message: error, type: "error", duration: 6000 } })
    })
}

// Wachtwoord resetten
export const doPasswordReset = (email, dispatch, callback) => {
  auth.sendPasswordResetEmail(email)
    .then(function (firebaseUser) {
      if (callback) {
        callback(firebaseUser)
      }
      dispatch({ type: actions.SET_ERROR, error: { message: "Er is een e-mail verzonden naar het opgegeven account", type: "info", duration: 6000 } })
    })
    .catch(function (error) {
      dispatch({ type: actions.SET_ERROR, error: { message: error, type: "error", duration: 6000 } })
    })
}

// Opnieuw authenticeren
export function reAuthenticate(dispatch, callback) {
  const currentUser = auth.currentUser
  if (currentUser) {
    currentUser.getIdToken(true)
      .then(function (idToken) {
        const userinfo = {
          uid: currentUser.uid,
          token: idToken,
          name: currentUser.displayName,
          email: currentUser.email,
          verified: currentUser.verified
        }

        if (callback) {
          callback(userinfo)
        }

        dispatch({ type: actions.SET_AUTH_USER, userinfo: userinfo })
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: error, type: "error", duration: 6000 } })
      })
  }
}

// Anoniem inloggen
export function doSignInAnonymously(dispatch, callback) {
  auth.signInAnonymously()
    .then(function (firebaseUser) {
      if (firebaseUser) {
        const userinfo = {
          uid: firebaseUser.user.uid,
          token: firebaseUser.user.xa
        }

        if (callback) {
          callback(userinfo)
        }

        dispatch({ type: actions.SET_AUTH_USER, userinfo: userinfo })
      }
    })
    .catch(function (error) {
      dispatch({ type: actions.SET_ERROR, error: { message: error, type: "error", duration: 6000 } })
    })
}

// Uitloggen
export function doSignOut(dispatch, callback) {
  auth.signOut()
    .then(() => {
      const userinfo = { uid: "", token: "", name: "", email: "", verified: "" }

      if (callback) {
        callback(userinfo)
      }

      dispatch({ type: actions.SET_AUTH_USER, userinfo: userinfo })
    })
    .catch(function (error) {
      dispatch({ type: actions.SET_ERROR, error: { message: error, type: "error", duration: 6000 } })
    })
}

// observer van firebase authenticatie
export function onAuthStateChanged(dispatch, callback) {
  auth.onAuthStateChanged((firebaseUser) => {
    let userinfo = { uid: "", token: "", name: "", email: "", verified: "" }

    if (firebaseUser) {
      userinfo = {
        uid: firebaseUser.uid,
        token: firebaseUser.xa,
        name: firebaseUser.displayName,
        email: firebaseUser.email,
        verified: firebaseUser.emailVerified
      }
    }

    if (callback) {
      callback(userinfo)
    }

    dispatch({ type: actions.SET_AUTH_USER, userinfo: userinfo })
  })
}

// Login met email en wachtwoord
export function doSignInWithEmailAndPassword(email, password, dispatch, callback) {
  auth.signInWithEmailAndPassword(email, password)
    .then(function (firebaseUser) {
      if (firebaseUser) {
        const userinfo = {
          uid: firebaseUser.user.uid,
          token: firebaseUser.user.xa,
          name: firebaseUser.user.displayName,
          email: firebaseUser.user.email,
          verified: firebaseUser.user.emailVerified
        }

        if (callback) {
          callback(userinfo)
        }

        dispatch({ type: actions.SET_AUTH_USER, userinfo: userinfo })
      }
    })
    .catch(function (error) {
      dispatch({ type: actions.SET_ERROR, error: { message: error, type: "error", duration: 6000 } })
    })
}
